import React, { LegacyRef } from 'react';
import GeoSuggest, { Suggest } from 'react-geosuggest';
import './LocationInputReactGeosuggest.css';
import { Form } from 'react-bootstrap';

export interface LocationInputProps {
  label: JSX.Element;
  value?: string;
  onSelect: (data: {
    latitude: number;
    longitude: number;
    label: string | undefined;
    formattedAddress: string | undefined;
    name: string | undefined;
  }) => void;
  locationBias?: { latitude: number; longitude: number };
  countries?: string[];
}

export interface LocationInputHandlerParam {
  latitude: number;
  longitude: number;
  label?: string;
  formattedAddress?: string;
  name?: string;
}

// eslint-disable-next-line react/display-name
export const LocationInput = React.forwardRef<GeoSuggest, LocationInputProps>(
  (
    { label, value, onSelect, locationBias, countries }: LocationInputProps,
    ref: LegacyRef<GeoSuggest>
  ) => {
    function handleSelection(data: Suggest | string) {
      if (data != undefined && typeof data != 'string') {
        const result = data.gmaps as google.maps.places.PlaceResult;
        onSelect({
          latitude: data.location.lat,
          longitude: data.location.lng,
          label: data.label,
          formattedAddress: result.formatted_address,
          name: result.name,
        });
      } else {
        onSelect({
          latitude: 0,
          longitude: 0,
          label: undefined,
          formattedAddress: undefined,
          name: undefined,
        });
      }
    }

    const geoSuggestOptionalProps: Record<string, any> = {};
    if (locationBias && typeof google !== 'undefined' && google.maps && google.maps.LatLng) {
      geoSuggestOptionalProps.location = new google.maps.LatLng(
        locationBias.latitude,
        locationBias.longitude
      );
      geoSuggestOptionalProps.radius = 300000; // in meters
    }
    if (countries && countries.length > 0) {
      geoSuggestOptionalProps.country = countries;
    }

    return (
      <>
        <Form.Label className='input-lbl'>{label}</Form.Label>
        <GeoSuggest
          ref={ref}
          placeholder=''
          initialValue={value}
          onSuggestSelect={(data: Suggest) => handleSelection(data)}
          onSuggestNoResults={() => handleSelection('')}
          inputClassName='txt-input form-control'
          autoComplete='off'
          {...geoSuggestOptionalProps}
        />
      </>
    );
  }
);
